const actions = {
  async addProductIdToGlobalCart(context, payload) {
    context.commit('appendB2bGlobalProducts', payload);
  },
  removeLineItemFromCart(context, payload) {
    let recipient = context.getters.recipients.find(
      (rec) => rec.lineitem?.id === payload.cartLineId
    );

    if (!recipient) {
      // eslint-disable-next-line no-console
      console.warn('removeLineItemFromCart, recipient not found', {
        recipients: (context.getters.recipients || []).map(
          (r) => r.lineitem?.id
        ),
        cartLineId: payload.cartLineId,
        payload
      });

      const { productId, contactId } = payload;
      if (productId && contactId) {
        recipient = context.getters.recipients.find(
          (rec) =>
            rec.id === contactId &&
            rec.lineitem?.merchandise?.product?.id === productId
        );

        // eslint-disable-next-line no-console
        console.warn('removeLineItemFromCart, recipient found via fallback', {
          recipient: { ...recipient }
        });
      }

      if (!recipient) {
        return;
      }
    }

    context.getters.cartInstance.updateQuantity(
      payload.cartLineId,
      payload.variantId,
      0,
      () => {
        context
          .dispatch('processCarts', { market: recipient.market })
          .then(() => {
            context.commit('removeUserProductFromGlobalCart', {
              lineItemId: recipient.id,
              productId: recipient.lineitem.merchandise.product.id
            });
          });
        window.dispatchEvent(
          new CustomEvent('cart-changed', {
            detail: {
              cart: context.getters.cartInstance.getCart()
            }
          })
        );
      }
    );
  },
  removeLineItemsFromCart(context, payload) {
    if (context.getters.isB2B) {
      payload.forEach((item) => {
        context.commit('removingContactItem', item);
      });
    }

    context.getters.cartInstance.multiUpdateQuantity(payload, 0, () => {
      window.dispatchEvent(
        new CustomEvent('cart-changed', {
          detail: {
            cart: context.getters.cartInstance.getCart()
          }
        })
      );
    });

    context.dispatch('processCarts').then(() => {});
  },
  setCartLoaded(context) {
    context.commit('setCartLoaded', true);
  }
};

export default actions;
